import React from 'react';
import { Helmet } from 'react-helmet';
import Banner from './Banner';
import ProductCategories from './ProductCategories';
import FeaturesSection from './FeaturesSection';
import ContactUs from './ContactUs';

const Home = () => {
  return (
    <div>
      <Helmet>
        <title>
          Plastic Safety Eyes Manufacturer in India | Soft Toy Eyes Supplier Delhi | Pushkar Enterprises
        </title>

        <meta
          name="description"
          content="Pushkar Enterprises is a leading plastic safety eyes manufacturer in India. Bulk supplier of soft toy eyes, toy noses, and plush accessories from Delhi."
        />

        <meta
          name="keywords"
          content="plastic safety eyes manufacturer India, soft toy eyes supplier Delhi, teddy bear eyes wholesale, toy noses manufacturer India, amigurumi eyes bulk"
        />

        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://pushkarenterprises.ltd" />

        <meta
          property="og:title"
          content="Plastic Safety Eyes Manufacturer in India | Pushkar Enterprises"
        />
        <meta
          property="og:description"
          content="Bulk supplier of soft toy eyes, amigurumi eyes & toy accessories. Trusted manufacturer based in Delhi."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://pushkarenterprises.ltd" />
      </Helmet>

      <Banner />
      <ProductCategories />
      <FeaturesSection />
      <ContactUs />

      {/* 🔥 MAIN SEO CONTENT */}
      <section style={{ padding: '2rem', maxWidth: '900px', margin: '0 auto' }}>
        
        <h1>Plastic Safety Eyes Manufacturer in India</h1>

        <h2>Soft Toy Eyes, Teddy Bear Eyes & Toy Noses Supplier in Delhi</h2>

        <p>
          <strong>Pushkar Enterprises</strong> is a leading 
          <strong> plastic safety eyes manufacturer in India</strong> specializing in 
          <strong> soft toy eyes, teddy bear eyes, amigurumi eyes, and toy noses</strong>. 
          We supply high-quality plastic components to toy manufacturers, exporters, and wholesalers across India and worldwide.
        </p>

        <p>
          Our product range includes <strong>crystal eyes, sparkle eyes, printed eyes, button eyes</strong>, 
          and various styles designed for plush toys, stuffed animals, and crochet toys. 
          All products are manufactured using high-quality materials to ensure durability, safety, and premium finish.
        </p>

        <p>
          As a trusted <strong>soft toy eyes supplier in Delhi</strong>, we focus on bulk manufacturing, 
          competitive pricing, and consistent quality for large-scale orders.
        </p>

        <h2>Why Choose Pushkar Enterprises?</h2>

        <ul>
          <li>25+ years of manufacturing experience</li>
          <li>Bulk supply for manufacturers and exporters</li>
          <li>Wide range of sizes, colors, and designs</li>
          <li>Strong locking safety eyes for plush toys</li>
          <li>Competitive factory-direct pricing</li>
        </ul>

        <p>
          Looking for a reliable supplier of plastic safety eyes and toy accessories? 
          <a href="/contact"> Contact Pushkar Enterprises</a> today for bulk orders and wholesale inquiries.
        </p>

      </section>
    </div>
  );
};

export default Home;